import { ComponentProps } from 'react';
import Navigation, { NavigationRootItem } from './navigation';

type AccountNavItemProps = ComponentProps<typeof Navigation>;

const AccountNavItem = ({ currentBlade, toggleBlade, className, menu }: AccountNavItemProps) => (
  <NavigationRootItem
    bladeClassName="right-0"
    className={className}
    currentBlade={currentBlade}
    item={menu.right.account}
    tag="div"
    toggleBlade={toggleBlade}
  />
);

export default AccountNavItem;
